<section (click)="setSortBy()">
  <span class="user-select-none text" [innerText]="title"></span>
  <ng-container *ngIf="sortBy === column">
    <tr-icon *ngIf="orderAscending === false" [icon]="icon.sortableDown" [size]="iconSize.small"></tr-icon>
    <tr-icon *ngIf="orderAscending === true" [icon]="icon.sortableUp" [size]="iconSize.small"></tr-icon>
  </ng-container>
  <ng-container *ngIf="sortBy !== column && showInactiveIcon">
    <tr-icon [icon]="icon.sorting" [size]="iconSize.small"></tr-icon>
  </ng-container>
</section>
